"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var loadPixelTrackingUrl_1 = require("../utils/loadPixelTrackingUrl");
var owa_analytics_1 = require("owa-analytics");
var universalCookies_1 = require("owa-service/lib/universalCookies");
var owa_strings_1 = require("owa-strings");
var TaboolaAdApiEndPointFormat = 'https://api.taboola.com/1.2/json/{0}/recommendations.multiple-get?app.type=desktop&app.apikey={1}&placement1.name={2}&placement1.rec-count=1&placement1.organic-type={3}&user.session={4}&source.type=section&user.agent={5}&source.id={6}&source.url={7}&device.id={8}&user.id={9}';
var TaboolaGetUserEndPointFormat = 'https://api.taboola.com/1.2/json/{0}/user.sync?app.type=desktop&app.apikey={1}';
var TaboolaNotifyVisibleFormat = 'https://api.taboola.com/1.2/json/{0}/recommendations.notify-visible?app.type=desktop&app.apikey={1}&response.id={2}&response.session={3}';
var TaboolaApiKey = '5b8cb6ece5c7b124b55d084f3a6ee7520d2f0966';
var TaboolaAdSourceId = 'inbox';
var TaboolaAdSourceUrl = 'https://outlook.live.com/owa';
var TaboolaPGMapping = {
    'en-ar': 'argentina',
    'es-ar': 'argentina',
    'en-au': 'australia',
    'de-at': 'austria-de',
    'en-at': 'austria-de',
    'fr-be': 'belgium-fr',
    'nl-be': 'belgium-nl',
    'en-br': 'brazil',
    'pt-br': 'brazil',
    'en-ca': 'canada',
    'fr-ca': 'canada',
    'en-cl': 'chile',
    'es-cl': 'chile',
    'zh-cn': 'china',
    'en-co': 'colombia',
    'es-co': 'colombia',
    'es-cr': 'costarica',
    'da-dk': 'denmark',
    'en-dk': 'denmark',
    'es-do': 'dominicanrepublic',
    'es-ec': 'ecuador',
    'ar-eg': 'egypt',
    'en-eg': 'egypt',
    'en-fi': 'finland',
    'fi-fi': 'finland',
    'fr-fr': 'france',
    'de-de': 'germany-de',
    'en-de': 'germany-de',
    'el-gr': 'greece',
    'en-gr': 'greece',
    'es-gt': 'guatemala',
    'en-hk': 'hongkong',
    'zh-hk': 'hongkong',
    'en-in': 'india-en',
    'en-id': 'indonesia',
    'id-id': 'indonesia',
    'en-ie': 'ireland',
    'it-it': 'italy',
    'ja-jp': 'japan',
    'ko-kr': 'korea',
    'en-my': 'malaysia',
    'ms-my': 'malaysia',
    'en-mx': 'mexico',
    'es-mx': 'mexico',
    'en-nl': 'netherlands',
    'nl-nl': 'netherlands',
    'en-nz': 'newzealand',
    'en-no': 'norway',
    'nb-no': 'norway',
    'en-pe': 'peru',
    'es-pe': 'peru',
    'en-ph': 'philippines',
    'fil-ph': 'philippines',
    'en-pl': 'poland',
    'pl-pl': 'poland',
    'en-pt': 'portugal',
    'pt-pt': 'portugal',
    'en-ru': 'russia',
    'ru-ru': 'russia',
    'ar-sa': 'saudiarabia',
    'en-sa': 'saudiarabia',
    'en-sg': 'singapore',
    'zh-sg': 'singapore',
    'en-za': 'southafrica',
    'es-es': 'spain-es',
    'en-se': 'sweden',
    'sv-se': 'sweden',
    'de-ch': 'switzerland-de',
    'en-ch': 'switzerland-de',
    'fr-ch': 'switzerland-de',
    'zh-tw': 'taiwan',
    'en-th': 'thailand',
    'th-th': 'thailand',
    'en-tr': 'turkey',
    'tr-tr': 'turkey',
    'ar-ae': 'uae-ar',
    'en-ae': 'uae-ar',
    'en-gb': 'uk',
    'en-us': 'us',
    'es-us': 'us',
    'es-ve': 'venezuela',
    'en-vn': 'vietnam',
    'vi-vn': 'vietnam',
};
var isOneClick;
var taboolaPublisherId;
var taboolaPlacementName;
var taboolaPlacementOrganicType;
var userMuid;
var loadTaboolaNativeAdsDataPoint;
var taboolaUserId;
var taboolaUserSessionId;
function fetchTaboolaNativeAds(messageAdType, plannedMessageAdType, adMarket, triggerEvent) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var getTaboolaUserEndPoint, getUserResponse, error_1, getUserResponseBody, taboolaRawUserObjectResponse;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadTaboolaNativeAdsDataPoint = new owa_analytics_1.PerformanceDatapoint('LoadTaboolaNativeAds');
                    isOneClick =
                        messageAdType == "TaboolaOneClick" /* TaboolaOneClick */ ||
                            messageAdType == "TaboolaOneClickOIO" /* TaboolaOneClickOIO */;
                    loadTaboolaNativeAdsDataPoint.addCustomData({
                        messageAdType: messageAdType,
                        userMarket: adMarket,
                        originalMessageAdType: plannedMessageAdType,
                        refreshEvent: triggerEvent,
                    });
                    // Set the Taboola publisher Id
                    taboolaPublisherId = TaboolaPGMapping[adMarket]
                        ? owa_strings_1.format('msn-outlookcom-{0}', TaboolaPGMapping[adMarket])
                        : 'msn-outlookcom-us';
                    taboolaPlacementName = isOneClick ? 'Inbox_Text_Widget' : 'Inbox_Two_Click_Widget';
                    taboolaPlacementOrganicType = 'mix';
                    userMuid = universalCookies_1.getCookie('MUID');
                    if (!taboolaUserId) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetchTaboolaNativeAdsWithUserId(messageAdType, plannedMessageAdType, adMarket, triggerEvent)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    getTaboolaUserEndPoint = owa_strings_1.format(TaboolaGetUserEndPointFormat, taboolaPublisherId, TaboolaApiKey);
                    _a.label = 3;
                case 3:
                    _a.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, fetch(getTaboolaUserEndPoint)];
                case 4:
                    getUserResponse = _a.sent();
                    return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (!(getUserResponse && getUserResponse.ok)) return [3 /*break*/, 9];
                    return [4 /*yield*/, getUserResponse.text()];
                case 7:
                    getUserResponseBody = _a.sent();
                    taboolaRawUserObjectResponse = JSON.parse(getUserResponseBody);
                    taboolaUserId = taboolaRawUserObjectResponse.user.id;
                    return [4 /*yield*/, fetchTaboolaNativeAdsWithUserId(messageAdType, plannedMessageAdType, adMarket, triggerEvent)];
                case 8: return [2 /*return*/, _a.sent()];
                case 9: return [4 /*yield*/, fetchTaboolaNativeAdsWithUserId(messageAdType, plannedMessageAdType, adMarket, triggerEvent)];
                case 10: 
                // Even if we fail to get the user id, let's go ahead to fetch the Taboola Ad
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.default = fetchTaboolaNativeAds;
function fetchTaboolaNativeAdsWithUserId(messageAdType, plannedMessageAdType, adMarket, triggerEvent) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var taboolaApiEndPoint, taboolaAdResponse, error_2, logClientError, taboolaAdResponseBody, taboolaNativeAdRawResponse, taboolaNativeAd, responseId, result, taboolaAd, notifyVisibleTrackingUrl, logClientError, logClientError;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    taboolaApiEndPoint = owa_strings_1.format(TaboolaAdApiEndPointFormat, taboolaPublisherId, TaboolaApiKey, taboolaPlacementName, taboolaPlacementOrganicType, encodeURIComponent(taboolaUserSessionId ? taboolaUserSessionId : 'init'), encodeURIComponent(navigator.userAgent), encodeURIComponent(TaboolaAdSourceId), encodeURIComponent(TaboolaAdSourceUrl), encodeURIComponent(userMuid), encodeURIComponent(taboolaUserId));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetch(taboolaApiEndPoint)];
                case 2:
                    taboolaAdResponse = _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    logClientError = new Error('TaboolaFetchAdError: ' + error_2);
                    loadTaboolaNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
                    return [2 /*return*/, null];
                case 4:
                    if (!(taboolaAdResponse && taboolaAdResponse.ok)) return [3 /*break*/, 6];
                    return [4 /*yield*/, taboolaAdResponse.text()];
                case 5:
                    taboolaAdResponseBody = _a.sent();
                    taboolaNativeAdRawResponse = JSON.parse(taboolaAdResponseBody);
                    // Set the Taboola User SessionId now to reuse in the next time in the same session
                    taboolaUserSessionId = taboolaNativeAdRawResponse.session;
                    taboolaNativeAd = void 0;
                    responseId = void 0;
                    if (taboolaNativeAdRawResponse.Inbox_Text_Widget &&
                        taboolaNativeAdRawResponse.Inbox_Text_Widget.list) {
                        taboolaNativeAd = taboolaNativeAdRawResponse.Inbox_Text_Widget.list[0];
                        responseId = taboolaNativeAdRawResponse.Inbox_Text_Widget.id;
                    }
                    else if (taboolaNativeAdRawResponse.Inbox_Two_Click_Widget &&
                        taboolaNativeAdRawResponse.Inbox_Two_Click_Widget.list) {
                        taboolaNativeAd = taboolaNativeAdRawResponse.Inbox_Two_Click_Widget.list[0];
                        responseId = taboolaNativeAdRawResponse.Inbox_Two_Click_Widget.id;
                    }
                    if (taboolaNativeAd) {
                        result = [];
                        taboolaAd = void 0;
                        taboolaAd = {
                            adSender: taboolaNativeAd.branding,
                            adSubject: taboolaNativeAd.name,
                            adPreviewTexts: taboolaNativeAd.description
                                ? taboolaNativeAd.description
                                : taboolaNativeAd.name,
                            adImageUrl: taboolaNativeAd.thumbnail[0].url,
                            adImageTargetUrl: taboolaNativeAd.url,
                            adType: messageAdType,
                            adChoiceUrl: 'https://popup.taboola.com',
                            adMarket: adMarket,
                            adRefreshEvent: triggerEvent,
                            adOneClickDirectTargetUrl: isOneClick ? taboolaNativeAd.url : null,
                            isRead: false,
                        };
                        notifyVisibleTrackingUrl = owa_strings_1.format(TaboolaNotifyVisibleFormat, taboolaPublisherId, TaboolaApiKey, encodeURIComponent(responseId), encodeURIComponent(taboolaUserSessionId));
                        loadPixelTrackingUrl_1.loadPixelTrackingUrl(notifyVisibleTrackingUrl);
                        result.push(taboolaAd);
                        loadTaboolaNativeAdsDataPoint.end();
                        return [2 /*return*/, result];
                    }
                    else {
                        logClientError = new Error('TaboolaNoValidAd: ' + taboolaAdResponseBody);
                        loadTaboolaNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
                        return [2 /*return*/, null];
                    }
                    return [3 /*break*/, 7];
                case 6:
                    logClientError = new Error('TaboolaNotOKResponse: ' + taboolaAdResponse.statusText);
                    loadTaboolaNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
                    return [2 /*return*/, null];
                case 7: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=fetchTaboolaNativeAds.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-messagead-orchestration/lib/services/fetchTaboolaNativeAds.js
// module id = 6015
// module chunks = 67